import React from 'react';
import useClockTime from '../useClockTime';

const DESIGN_W = 380;
const DESIGN_H = 140;

const DigitalClassic = ({
  textColor = '#1f3a5f',
  fontFamily,
  accentColor = '#c8a84b',
}) => {
  const { hours24, minutes, seconds } = useClockTime();

  const hh = String(hours24).padStart(2, '0');
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');

  const numStyle = {
    fontSize: 88,
    fontWeight: 700,
    color: textColor,
    fontFamily: fontFamily || 'inherit',
    fontVariantNumeric: 'tabular-nums',
    lineHeight: 1,
    width: 120,
    textAlign: 'center',
    display: 'block',
    flexShrink: 0,
  };
  const colonStyle = {
    fontSize: 78,
    fontWeight: 700,
    color: accentColor,
    fontFamily: fontFamily || 'inherit',
    lineHeight: 1,
    width: 20,
    textAlign: 'center',
    flexShrink: 0,
    userSelect: 'none',
  };

  return (
    <div style={{ width: DESIGN_W, height: DESIGN_H, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center', direction: 'ltr' }}>
        <span style={numStyle}>{hh}</span>
        <span style={colonStyle}>:</span>
        <span style={numStyle}>{mm}</span>
        <span style={colonStyle}>:</span>
        <span style={numStyle}>{ss}</span>
      </div>
    </div>
  );
};

export default DigitalClassic;
